import { Component, ViewChild } from "@angular/core";
import {
  BsModalRef,
  BsModalService,
  ModalDirective,
} from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "src/app/core/services/alert.service";
import { HttpService } from "src/app/core/services/http.service";
import { User } from "src/app/core/models/user.model";

@Component({
  selector: "app-user-edit-modal",
  templateUrl: "./user-edit-modal.component.html",
  styleUrls: ["./user-edit-modal.component.css"],
})
export class UserEditModalComponent {
  @ViewChild("modalReason", { static: false })
  modalReason?: ModalDirective;
  user: User;
  withdrawalData: any;
  public bsModalRef?: BsModalRef;
  userId: any;
  userData: any;
  ages = [10, 20, 30, 40, 50, 60];
  country: any;
  constructor(
    public modalService: BsModalService,
    private httpService: HttpService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService
  ) {}

  async ngOnInit(): Promise<void> {
    this.country = await this.httpService.doGet(`/get/contries/name`);
    this.userData = this.user;
    console.log("this.userData =", this.userData);
    // this.getData();
  }
  async getData() {
    try {
      this.spinner.show();
      let httpResult = await this.httpService.doGet(
        `/admin-member-api/findOne/${this.userId}`,
        false
      );
      this.userData = httpResult.result;

      this.userData.sex = this.userData.sex ? this.userData.sex : "";
      this.userData.age = this.userData.age ? this.userData.age : "";
      this.userData.country = this.userData.country
        ? this.userData.country
        : "";

      if (this.userData.restrict === "탈퇴회원") {
        let httpResult2 = await this.httpService.doGet(
          `/admin-member-api/findOne/withdrawal/${this.userId}`,
          false
        );
        this.withdrawalData = httpResult2.result;
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      this.alertService.errormsg("데이터를 불러오는 도중 문제가 생겼습니다.");
    }
  }

  isPastDate(dateString: string): boolean {
    const currentDate = new Date(); // 현재 날짜
    const inputDate = new Date(dateString); // dateString을 Date 객체로 변환

    // 입력된 날짜가 현재보다 과거인지 체크
    return inputDate < currentDate;
  }

  async saveUser() {
    let object = {
      name: this.userData.name,
      sex: this.userData.sex,
      age: this.userData.age,
      country: this.userData.country,
    };

    let reObject = Object.entries(object).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    await this.httpService.doPatch(
      `/admin-member-api/update/one/${this.userId}`,
      reObject
    );

    this.alertService.successmsg("수정되었습니다.").then(() => {
      this.modalService.hide();
    });
  }
}
